module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-4 border border-solid border-gray-200 rounded-lg px-4"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3"
  }, [(_vm.title === 'Google Classroom') ? _c('img', {
    staticClass: "w-8 h-8 rounded-full",
    attrs: {
      "src": _vm.icon
    }
  }) : _c('img', {
    staticClass: "w-8 h-8 rounded-full",
    attrs: {
      "src": ("/static/integrations/" + _vm.title + ".png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-base font-poppins font-semibold text-gray-800"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])]), _vm._v(" "), _c('div', [(_vm.loading) ? _c('pl-spinner') : [(_vm.type === 'connect') ? _c('div', {
    staticClass: "flex items-center space-x-3 font-manrope"
  }, [_c('Tooltip', {
    attrs: {
      "text": "Go to your profile (bottom left) > click integrations to disconnect and reconnect Google Classroom option. This should it!",
      "styleTooltip": "top-0 right-full mr-2.5 -mt-1 shadow-md text-gray-800",
      "backgroundColor": "bg-white",
      "textColor": "text-gray-800"
    }
  }, [(_vm.title === 'Google Classroom') ? _c('button', {
    staticClass: "rounded-full mt-1 mr-1.5 flex items-center space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-question"
  }), _vm._v(" "), _c('span', [_vm._v("Connection not working")])]) : _vm._e()]), _vm._v(" "), (!_vm.integration_connected) ? _c('button', {
    staticClass: "sample font-manrope py-2 w-36 bg-primary font-semibold hover:bg-primary-dark rounded cursor-pointer text-white disabled:opacity-50",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.connectIntegration
    }
  }, [_vm._v("\n            Connect\n          ")]) : _vm._e()], 1) : _c('div', [_c('button', {
    staticClass: "px-8 py-2 font-manrope bg-primary hover:bg-primary-dark font-semibold rounded cursor-pointer mr-7 text-white disabled:opacity-50",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.syncIntegration
    }
  }, [_vm._v("\n            Sync Assessment\n          ")])])]], 2), _vm._v(" "), (_vm.integration_connected && _vm.type === 'connect') ? _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "flex items-center justify-end mb-2"
  }, [(_vm.account_integration && _vm.account_integration.email) ? _c('span', {
    staticClass: "text-xs text-gray-500 mr-4"
  }, [_vm._v("\n          " + _vm._s(_vm.account_integration.email) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "py-2 w-36 bg-red-400 rounded cursor-pointer font-semibold text-white disabled:opacity-50",
    on: {
      "click": function($event) {
        return _vm.disconnectClass()
      }
    }
  }, [_vm._v("\n          Disconnect\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-end"
  }, [_c('span', {
    staticClass: "text-xs text-gray-500 mr-4"
  }, [_vm._v("\n          " + _vm._s(_vm.integration_course_name) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "py-2 w-36 bg-primary hover:bg-primary-dark font-semibold rounded cursor-pointer text-white disabled:opacity-50",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.updateRoster()
      }
    }
  }, [_vm._v("\n          Update Roster\n        ")])])]) : _vm._e()]), _vm._v(" "), (_vm.show_integrations_premium_feature_modal) ? _c('integrations-premium-feature-modal', {
    on: {
      "close": function($event) {
        _vm.show_integrations_premium_feature_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_integrations_upgrade_modal) ? _c('integrations-upgrade-modal', {
    attrs: {
      "integration_name": _vm.integration.name,
      "integration_id": _vm.integration.integration_id
    },
    on: {
      "close": function($event) {
        _vm.show_integrations_upgrade_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.google_classroom_modal) ? _c('google-classroom-modal', {
    attrs: {
      "courses": _vm.courses
    },
    on: {
      "close": function($event) {
        _vm.google_classroom_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_disconnect_classroom_modal) ? _c('disconnect-google-classroom-modal', {
    on: {
      "close": function($event) {
        _vm.show_disconnect_classroom_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_disconnect_integration_modal) ? _c('disconnect-integration-modal', {
    attrs: {
      "integration": _vm.integration
    },
    on: {
      "close": function($event) {
        _vm.show_disconnect_integration_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-8d7f15f0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/integrationCard.vue
// module id = 1019
// module chunks = 61